import EditJobModal from 'components/V2/EditJobModal';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import ExperienceModal from 'scenes/Dashboard/V2/ExperienceModal/ExperienceModal';
import { approveAthleticTrainer, bulkTransition, decline, removeJob } from 'redux/ducks/Job';
import { getAthleticTrainer, update } from 'redux/ducks/User';
import { connect } from 'react-redux';
import { getTimezone } from 'helpers/post';
import ConfirmationModal from 'components/V2/ConfirmationModal';
import classNames from 'classnames';
import {
  blockedByFailedPayment,
  hasToVerifyMicroDeposits,
  pendingUnblockFailedPayment,
} from 'helpers/payment';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import CustomCheckBox from 'components/V2/CustomInputs/CustomCheckBox';
import { MILITARY_FORMAT } from 'helpers/datetime';
import CancelJobModal from 'components/V2/ConfirmationModal/CancelJobModal';
import { jobsInStateFromEvent, convertToMilitaryFormat } from 'helpers/dashboard';
import BulkAcceptComponent from './BulkAcceptComponent';
import {
  triggerBlockedFailedPaymentModal,
  triggerWaitUntilFailedPaymentProcessModal,
} from 'redux/ducks/Modals';

const STATUS_PANEL = {
  pending: {
    name: 'APPLIED',
    statusColor: 'black',
  },
  eo_accepted_at: {
    name: 'PENDING CONFIRMATION',
    statusColor: 'black',
  },
  confirmed: {
    name: 'CONFIRMED',
    statusColor: 'teal',
  },
  checked_in: {
    name: 'CHECKED IN',
    statusColor: 'teal',
  },
  waitlist: {
    name: 'WAITLIST',
    statusColor: 'black',
  },
  callout: {
    name: 'CALLOUT',
    statusColor: 'grey',
  },
  decommitted: {
    name: 'CALLOUT',
    statusColor: 'grey',
  },
  eo_removed_at: {
    name: 'REMOVED',
    statusColor: 'grey',
  },
  paid: {
    name: 'PAID',
    statusColor: 'black',
  },
  backout: {
    name: 'WITHDRAWN',
    statusColor: 'black',
  },
  callout_shift_change: {
    name: 'CALLOUT',
    statusColor: 'grey',
  },
  no_show: {
    name: 'NO SHOW',
    statusColor: 'grey',
  },
};

const DISPLAY_BUTTONS = {
  pending: ['accept', 'decline'],
  eo_accepted_at: ['remove'],
  confirmed: ['edit', 'cancel'],
  checked_in: ['edit'],
  waitlist: ['remove'],
  callout: [],
  paid: [],
  decommitted: [],
  backout: [],
  eo_removed_at: [],
};

const MAP_BUTTON_NAME = {
  accept: {
    buttonText: 'ACCEPT',
    color: 'teal',
  },
  decline: {
    buttonText: 'DECLINE',
    color: 'grey',
  },
  edit: {
    buttonText: 'EDIT JOB',
    color: 'teal',
  },
  remove: {
    buttonText: 'REMOVE',
    color: 'grey',
  },
  cancel: {
    buttonText: 'CANCEL',
    color: 'grey',
  },
};

export const getStateStatus = state => {
  return STATUS_PANEL[state] || { name: 'UNKNOWN', statusColor: 'grey' };
};

class JobActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openEditJob: false,
      openDeclineModal: false,
      openRemoveModal: false,
      openCancelModal: false,
      openBulkAcceptModal: false,
      verifyPaymentModal: false,
      acceptApplicationModal: false,
      acceptApplicationBoxChecked: props.currentUser.acceptApplicationBoxChecked,
      collapseEstimatedFee: false,
    };
  }

  toggleAcceptApplicationModal = () => {
    this.setState(prevState => ({
      ...prevState,
      acceptApplicationModal: !this.state.acceptApplicationModal,
    }));
  };

  toggleEditJob = () => {
    this.setState(prevState => ({
      ...prevState,
      openEditJob: !this.state.openEditJob,
    }));
  };

  toggleVerifyPaymentModal = () => {
    this.setState(prevState => ({
      ...prevState,
      verifyPaymentModal: !this.state.verifyPaymentModal,
    }));
  };

  toggleDeclineModal = () => {
    this.setState(prevState => ({
      ...prevState,
      openDeclineModal: !this.state.openDeclineModal,
    }));
  };

  toggleRemoveModal = () => {
    this.setState(prevState => ({
      ...prevState,
      openRemoveModal: !this.state.openRemoveModal,
    }));
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({
      ...prevState,
      openCancelModal: !this.state.openCancelModal,
    }));
  };

  toggleEstimatedFeeModal = () => {
    this.setState(prevState => ({
      ...prevState,
      collapseEstimatedFee: !prevState.collapseEstimatedFee,
    }));
  };

  toggleBulkAcceptModal = () => {
    this.setState(prevState => ({
      ...prevState,
      openBulkAcceptModal: !prevState.openBulkAcceptModal,
    }));
  };

  onApprove = job => {
    this.props.approveTrainer(job);
  };

  onDecline = id => {
    this.props.decline(id);
  };

  onRemove = id => {
    this.props.remove(id);
  };

  buttonAction = button => () => {
    const { job, payment } = this.props;

    switch (button) {
      case 'accept':
        const { currentUser } = this.props;

        if (pendingUnblockFailedPayment(currentUser)) {
          this.props.toggleWaitUntilFailedPaymentProcess();
          return;
        }

        if (blockedByFailedPayment(currentUser)) {
          this.props.toggleBlockedForFailedPayments();
          return;
        }

        if (hasToVerifyMicroDeposits(payment) && !get(payment, 'source.id')) {
          this.toggleVerifyPaymentModal();
          break;
        }
        const { update } = this.props;
        const { acceptApplicationModal, acceptApplicationBoxChecked } = this.state;

        if (acceptApplicationModal || currentUser.acceptApplicationBoxChecked) {
          if (acceptApplicationBoxChecked !== currentUser.acceptApplicationBoxChecked) {
            update({ ...currentUser, acceptApplicationBoxChecked: true });
          }
          if (this.validJobsForBulkAccept().length >= 2) {
            this.toggleBulkAcceptModal();
            break;
          }
          this.onApprove(job);
        } else this.toggleAcceptApplicationModal();

        break;
      case 'decline':
        this.toggleDeclineModal();
        break;
      case 'edit':
        this.toggleEditJob();
        break;
      case 'remove':
        this.toggleRemoveModal();
        break;
      case 'cancel':
        this.toggleCancelModal();
        break;
      default:
        break;
    }
  };

  getAtTById = ATId => {
    const { pendingApplicants } = this.props;
    const ATIndex = pendingApplicants.findIndex(at => at.id === ATId);

    if (ATIndex !== -1) return;

    this.props.getAthleticTrainer(ATId);
  };

  goToVerifyPayment = () => {
    this.props.history.push('/edit-payment');
  };

  // Return if jobOne overlaps with jobTwo
  /*
    Example (return true)
    jobOne is schedule from 13:00 to 14:00
    jobTwo is schedule from 12:00 to 15:00
  */
  jobsOverlapping = (jobOne, jobTwo) => {
    return moment(jobOne.startTime, MILITARY_FORMAT).isBetween(
      moment(jobTwo.startTime, MILITARY_FORMAT),
      moment(jobTwo.endTime, MILITARY_FORMAT),
      undefined,
      '[]'
    );
  };

  overlapOverArray = (job, jobs) => {
    return jobs.map(j => this.jobsOverlapping(job, j)).some(el => el === true);
  };

  filterOverlappingJobs = jobs => {
    const visitedJobs = new Set();

    return jobs.reduce((result, job) => {
      if (visitedJobs.has(job.id)) return result;

      const filterCurrent = result.filter(j => j.id !== job.id);

      if (!this.overlapOverArray(job, filterCurrent)) {
        visitedJobs.add(job.id);
        result.push(job);
      }

      return result;
    }, []);
  };

  validJobsForBulkAccept = () => {
    const { shifts, job, shift, jobsMetadata } = this.props;
    if (!shifts) return;

    const eventLocation = get(shift, 'eventLocation');
    const tz = getTimezone(eventLocation);
    const filterShifts = shifts.filter(s => s.eventLocation.id === eventLocation.id);
    const pendingJobs = jobsInStateFromEvent({ shifts: filterShifts }, ['pending']);
    // Exclude shifts where Accept is disabled (overlap with an already-accepted job).
    // filterOverlappingJobs only de-dupes overlaps among pending jobs themselves.
    const filterPendingJobs = pendingJobs.filter(
      j =>
        j.userId === job.userId &&
        moment.tz(moment(j.endTime), tz).isAfter(moment.tz(moment(), tz)) &&
        !get(jobsMetadata, `[${j.id}].overlappingWithAnotherJob`, false)
    );
    const updatedJobs = convertToMilitaryFormat(filterPendingJobs, tz);

    return this.filterOverlappingJobs(updatedJobs);
  };

  acceptCurrentShift = job => {
    this.onApprove(job);
  };

  acceptForAllShifts = () => {
    const ids = this.validJobsForBulkAccept().map(job => job.id);
    this.props.bulkAccept(ids);
  };

  render() {
    const { job, pendingApplicants, shift, jobsMetadata, eventTitle } = this.props;
    const { user } = job;
    const buttons = DISPLAY_BUTTONS[job.currentState] || [];
    const tz = getTimezone(shift.eventLocation);
    const notPassedJob = moment(job.endTime).isAfter(moment());
    const jobStarted = moment(job.startTime).isAfter(moment());
    const canModifyJob = moment(job.endTime, MILITARY_FORMAT).add(12, 'hours').isAfter(moment());
    const acceptDisabled = get(jobsMetadata, `[${job.id}].overlappingWithAnotherJob`, null);
    const canDoAction = job.currentState === 'pending';
    const eventLocation = get(shift, 'eventLocation');
    const validJobsForBulkAccept = this.validJobsForBulkAccept();

    return (
      <React.Fragment>
        <div className={classNames('button-cell')}>
          <ExperienceModal
            onClick={() => this.getAtTById(user.id)}
            onApprove={this.buttonAction('accept')}
            onDecline={() => this.onDecline(job.id)}
            onRemove={() => this.onRemove(job.id)}
            id={user.id}
            pendingApplicants={pendingApplicants}
            from={this.props.from}
            canDoAction={canDoAction}
            job={job}
            jobState={get(eventLocation, 'address.state')}
            acceptDisabled={acceptDisabled}
            tz={tz}
            eventTitle={eventTitle}
          >
            VIEW PROFILE
          </ExperienceModal>
        </div>
        <div className={classNames('button-cell')}>
          {buttons.includes('accept') && notPassedJob && (
            <button
              id={`accept-${job.id}`}
              key={`key-button-accept`}
              className={classNames(`plain-button action-button ${MAP_BUTTON_NAME['accept'].color}`, {
                disabled: acceptDisabled,
              })}
              onClick={this.buttonAction('accept')}
              disabled={acceptDisabled}
            >
              {MAP_BUTTON_NAME['accept'].buttonText}
            </button>
          )}
          {acceptDisabled && (
            <UncontrolledTooltip target={`accept-${job.id}`}>
              You already accepted {user.name} for a shift during this time.
            </UncontrolledTooltip>
          )}
        </div>
        <div className={classNames('button-cell')}>
          {buttons.includes('edit') && canModifyJob && (
            <EditJobModal
              {...this.props}
              key={job.id}
              job={job}
              tz={tz}
              user={user}
              isOpen={this.state.openEditJob}
              toggleEditJob={this.toggleEditJob}
              childTextColor={MAP_BUTTON_NAME['edit'].color}
              location={shift.eventLocation}
            >
              <span onClick={this.props.onEdit}>{MAP_BUTTON_NAME['edit'].buttonText}</span>
            </EditJobModal>
          )}
        </div>
        <div className={classNames('button-cell')}>
          {buttons.includes('decline') && jobStarted && (
            <button
              key={`key-button-decline`}
              className={`plain-button action-button ${MAP_BUTTON_NAME['decline'].color}`}
              onClick={this.buttonAction('decline')}
            >
              {MAP_BUTTON_NAME['decline'].buttonText}
            </button>
          )}
          {buttons.includes('remove') && jobStarted && (
            <button
              key={`key-button-remove`}
              className={`plain-button action-button ${MAP_BUTTON_NAME['remove'].color}`}
              onClick={this.buttonAction('remove')}
            >
              {MAP_BUTTON_NAME['remove'].buttonText}
            </button>
          )}
          {buttons.includes('cancel') && jobStarted && (
            <button
              key={`key-button-cancel`}
              className={`plain-button action-button ${MAP_BUTTON_NAME['cancel'].color}`}
              onClick={this.buttonAction('cancel')}
            >
              {MAP_BUTTON_NAME['cancel'].buttonText}
            </button>
          )}
        </div>
        <ConfirmationModal
          isOpen={this.state.openDeclineModal}
          toggle={this.toggleDeclineModal}
          title="Decline Application"
          body={`Are you sure you want to decline this application from ${user.firstName} ${user.lastName}?`}
          onSave={() => this.onDecline(job.id)}
          cancelText="Go Back"
          confirmText="Decline"
          onCancel={this.toggleDeclineModal}
        />
        <ConfirmationModal
          isOpen={this.state.openRemoveModal}
          toggle={this.toggleRemoveModal}
          title="Remove Application"
          body={`Are you sure you want to remove this application from ${user.firstName} ${user.lastName}?`}
          onSave={() => this.onRemove(job.id)}
          cancelText="Go Back"
          confirmText="Remove"
          onCancel={this.toggleRemoveModal}
        />
        <CancelJobModal
          {...this.props}
          openCancelModal={this.state.openCancelModal}
          toggleCancelModal={this.toggleCancelModal}
          onRemove={this.props.remove}
          collapseEstimatedFee={this.state.collapseEstimatedFee}
          toggleEstimatedFeeModal={this.toggleEstimatedFeeModal}
        />
        <ConfirmationModal
          isOpen={this.state.verifyPaymentModal}
          toggle={this.toggleVerifyPaymentModal}
          title="Verify Payment Source"
          body={`You must verify your bank account with micro deposits before accepting applicants.`}
          onSave={this.goToVerifyPayment}
          cancelText="Cancel"
          confirmText="Verify"
          onCancel={this.toggleVerifyPaymentModal}
        />
        <ConfirmationModal
          isOpen={this.state.acceptApplicationModal}
          toggle={this.toggleAcceptApplicationModal}
          title="Accept Application"
          body={
            <React.Fragment>
              <p style={{ paddingBottom: '1rem' }}>
                Once accepted, athletic trainers have 48 hours to confirm the job. You will be notified via
                email when the athletic trainer confirms or if their application expires.
              </p>
              <p style={{ paddingBottom: '1rem' }}>
                <p className="warning-text" style={{ color: '#65647f', margin: 0 }}>
                  Important:
                </p>
                {` If the athletic trainer confirms the job and you choose to cancel later, fees will apply per the `}
                <a
                  href="https://www.go4.io/go4-marketplace-standards/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Go4 Cancellation Policy
                </a>
                .
              </p>
              <CustomCheckBox
                id="hide-notice"
                name="hide-notice"
                checked={this.state.acceptApplicationBoxChecked}
                onClick={() =>
                  this.setState({
                    acceptApplicationBoxChecked: !this.state.acceptApplicationBoxChecked,
                  })
                }
                className="gotham-regular-font"
              >
                <div className="p-0" style={{ top: '-4px', position: 'relative' }}>
                  Don’t show this again
                </div>
              </CustomCheckBox>
            </React.Fragment>
          }
          onSave={this.buttonAction('accept')}
          cancelText="Go Back"
          confirmText="Accept Applicant"
          onCancel={this.toggleAcceptApplicationModal}
        />
        <ConfirmationModal
          isOpen={this.state.openBulkAcceptModal}
          toggle={this.toggleBulkAcceptModal}
          title="Accept All Shifts?"
          htmlBody
          body={
            <BulkAcceptComponent user={user} jobs={validJobsForBulkAccept} eventLocation={eventLocation} />
          }
          onCancel={() => this.acceptCurrentShift(job)}
          cancelText="Accept Current Shift"
          confirmText="Accept All Listed Shifts"
          onSave={() => this.acceptForAllShifts()}
          largeButtons
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  payment: state.payment,
  jobsMetadata: state.dashboard.applicants.jobsMetadata,
  currentUser: state.session.currentUser,
  rateTypes: state.enums.rateTypes,
});

const mapDispatchToProps = dispatch => ({
  approveTrainer: job => dispatch(approveAthleticTrainer(job)),
  decline: id => dispatch(decline(id)),
  remove: (id, cancelReason) => dispatch(removeJob(id, cancelReason)),
  getAthleticTrainer: id => dispatch(getAthleticTrainer(id)),
  update: user => dispatch(update(user)),
  bulkAccept: ids =>
    dispatch(
      bulkTransition({
        jobIds: ids,
        toState: 'eo_accepted_at',
        fromState: 'pending',
      })
    ),
  toggleBlockedForFailedPayments: () => dispatch(triggerBlockedFailedPaymentModal()),
  toggleWaitUntilFailedPaymentProcess: () => dispatch(triggerWaitUntilFailedPaymentProcessModal()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobActions));
